"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpDropdownInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var yup = __importStar(require("yup"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var DpDropdownInput_styled_1 = require("./DpDropdownInput.styled");
var providers_1 = require("../../../providers");
var api_1 = require("../../../api");
var Constants_1 = require("../../Constants");
var generateOptions = function (date, interval, dateFormat, handler, selectedValue) {
    var options = [];
    var tracker = providers_1.dateProvider.isSameDay(date, new Date())
        ? (0, api_1.roundToInterval)(new Date(), interval)
        : providers_1.dateProvider.startOfDay(date);
    var cloned = providers_1.dateProvider.endOfDay(date);
    var counter = 0;
    while (providers_1.dateProvider.isBefore(tracker, cloned)) {
        var formattedDate = providers_1.dateProvider.formatByString(tracker, dateFormat);
        var selectedVal = !(0, isUndefined_1.default)(selectedValue)
            ? providers_1.dateProvider.formatByString(selectedValue, dateFormat)
            : undefined;
        options.push((0, jsx_runtime_1.jsx)("li", { "data-value": providers_1.dateProvider.formatByString(tracker, Constants_1.DATE_TIME_FULL_FORMAT), onMouseDown: handler, onKeyDown: (0, api_1.handleButtonPress)(handler), "data-index": counter, tabIndex: -1, role: "option", "aria-selected": formattedDate === selectedVal, children: formattedDate }, formattedDate));
        tracker = providers_1.dateProvider.addMinutes(tracker, interval);
        formattedDate = providers_1.dateProvider.formatByString(tracker, dateFormat);
        counter++;
    }
    return options;
};
var formattedValueValidationSchema = yup
    .string()
    .required()
    .matches(/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9] [p,a,P,A][m, M]$/, 'The typed in text is not a time');
var DpDropdownInput = function (_a) {
    var date = _a.date, name = _a.name, interval = _a.interval, dateFormat = _a.dateFormat, dateValidationSchema = _a.dateValidationSchema, selectionHandler = _a.selectionHandler, errorHandler = _a.errorHandler, _b = _a.isTimeSelected, isTimeSelected = _b === void 0 ? false : _b, id = _a.id;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var ref = (0, react_1.useRef)();
    var inputRef = (0, react_1.useRef)();
    var _c = (0, react_1.useState)(new Date()), value = _c[0], setValue = _c[1];
    var _d = (0, react_1.useState)("".concat(t('DpDropdownInput.addTime'))), formattedValue = _d[0], setFormattedValue = _d[1];
    var _e = (0, react_1.useState)(false), isMenuOpen = _e[0], setIsMenuOpen = _e[1];
    var _f = (0, react_1.useState)([]), options = _f[0], setOptions = _f[1];
    var _g = (0, api_1.useRoveFocus)(options.length, ref), focusIndex = _g[0], setFocusIndex = _g[1];
    var _h = (0, react_1.useState)(), selectedValue = _h[0], setSelectedValue = _h[1];
    (0, api_1.useMount)(function () {
        var closeDropDown = function (e) {
            var _a;
            if (((_a = e === null || e === void 0 ? void 0 : e.path) === null || _a === void 0 ? void 0 : _a.length) && e.path[0] !== ref.current && e.path[0] !== inputRef.current) {
                setIsMenuOpen(false);
            }
        };
        document.body.addEventListener('click', closeDropDown);
        return function () { return document.body.removeEventListener('click', closeDropDown); };
    });
    (0, react_1.useEffect)(function () {
        if (isTimeSelected)
            setFormattedValue(providers_1.dateProvider.formatByString(date, dateFormat));
        var handler = function (e) {
            var selectedTime = e.currentTarget.getAttribute('data-value');
            if (selectedTime) {
                var dateParsed = providers_1.dateProvider.parse(selectedTime, Constants_1.DATE_TIME_FULL_FORMAT);
                setValue(dateParsed);
                setFormattedValue(providers_1.dateProvider.formatByString(dateParsed, dateFormat));
            }
            setIsMenuOpen(false);
            ref.current.parentElement.querySelector('input').focus();
        };
        setOptions(generateOptions(date, interval, dateFormat, handler, selectedValue));
    }, [date, dateFormat, interval, isTimeSelected, selectedValue]);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = ref.current.querySelector("[data-index=\"".concat(focusIndex, "\"]"))) === null || _a === void 0 ? void 0 : _a.focus();
    }, [focusIndex]);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = ref.current.querySelector("[data-index='0']")) === null || _a === void 0 ? void 0 : _a.focus();
        if (isMenuOpen)
            setFocusIndex(0);
    }, [isMenuOpen, setFocusIndex]);
    var setTime = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, time, valueIsValid, err_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (formattedValue === t('DpDropdownInput.addTime'))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, formattedValueValidationSchema.validate(formattedValue)];
                case 2:
                    isValid = _a.sent();
                    if (formattedValue && isValid) {
                        time = providers_1.dateProvider.parse(formattedValue, dateFormat);
                        value.setHours(time.getHours());
                        value.setMinutes(time.getMinutes());
                    }
                    return [4 /*yield*/, dateValidationSchema.validate(value)];
                case 3:
                    valueIsValid = _a.sent();
                    if (value && valueIsValid) {
                        selectionHandler(value);
                        setSelectedValue(value);
                    }
                    errorHandler();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    error = err_1;
                    errorHandler(error);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleBlur = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setTime()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleKeyDown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.key === 'Enter' || e.key === 'ArrowDown'))
                        return [2 /*return*/];
                    setIsMenuOpen(!isMenuOpen);
                    return [4 /*yield*/, setTime()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (e) { return setFormattedValue(e.target.value); };
    var handleClick = function () { return setIsMenuOpen(!isMenuOpen); };
    var inputAriaLabel = (0, react_1.useMemo)(function () {
        return "".concat(t('DpDropdownInput.addTime'), " GMT ").concat(formattedValue === t('DpDropdownInput.addTime') ? '' : formattedValue);
    }, [formattedValue, t]);
    return ((0, jsx_runtime_1.jsxs)(DpDropdownInput_styled_1.StyledDropdownInput, { id: id, className: "dropdown-input", isMenuOpen: isMenuOpen, onBlur: handleBlur, children: [(0, jsx_runtime_1.jsx)("input", { value: formattedValue, onClick: handleClick, onChange: handleChange, onKeyDown: handleKeyDown, name: name, "aria-label": inputAriaLabel, ref: inputRef }), (0, jsx_runtime_1.jsx)("ul", { ref: ref, role: "listbox", tabIndex: 0, "aria-label": t('DpDropdownInput.selectTimeAriaLabel'), children: options })] }));
};
exports.DpDropdownInput = DpDropdownInput;
exports.default = exports.DpDropdownInput;
